export default __webpack_public_path__ + "static/media/avatar.d48aa71a.svg";